import isPropValid from "@emotion/is-prop-valid";
import { AxiosWrapper } from "components/ezpay/common/axios-wrapper/axios-wrapper";
import { awsWafUrl } from "config";
import React, { FunctionComponent } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import { StyleSheetManager } from "styled-components";
import { appConfig } from "../../../config";
import { envs } from "../../../config/index";
import createApiMiddleware from "../../../middleware/api";
import { rootReducer } from "../../../reducers";

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  process.env.REACT_APP_ENV !== envs.PRODUCTION
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(thunkMiddleware, createApiMiddleware())),
);

async function injectAwsWafScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = awsWafUrl;
    script.async = true;
    script.onload = () => resolve("");
    script.onerror = () => resolve(""); // Ignore error and resolve to continue loading the page
    document.head.appendChild(script);
  });
}

const basePath = appConfig.basePath;

/**
 * Export a function that takes an App component, and wraps it with the redux store provider and a
 * router before rendering
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default async (
  appComponent: FunctionComponent,
  containerId = "root",
) => {
  await injectAwsWafScript();

  const root = ReactDOM.createRoot(
    document.getElementById(containerId) as HTMLElement,
  );
  root.render(
    <StyleSheetManager
      // @ts-ignore shouldForwardProp is supported at runtime but missing from type defs
      shouldForwardProp={(propName: string, target: any) =>
        typeof target === "string" ? isPropValid(propName) : true
      }
    >
      <Provider store={store}>
        <AxiosWrapper>
          {/* @ts-ignore */}
          <BrowserRouter
            basename={basePath}
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            {React.createElement(appComponent)}
          </BrowserRouter>
        </AxiosWrapper>
      </Provider>
    </StyleSheetManager>,
  );
};
